import { Typography } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";


interface ILoading {
    className?:string
}


export function Loading({ className }:ILoading) {

    const Loading = <Typography variant="h3">
        <Skeleton height={80} key={Math.random()} className={className}/>
    </Typography>;
    const loadingList = [];

    for (let i = 0; i < 10; i++) {
        loadingList.push(Loading);
    }

    return <>
        {loadingList}
    </>;
}